import * as React from 'react';

import { EnterpriseBadge_UserState as EnterpriseBadgeUserState } from '__generated__/graphql-types';

import VerifiedSkillsBadgeDataContext from 'bundles/skills-common/shared/verified-skills/context/pathway-badge/VerifiedSkillsBadgeDataContext';
import { useSkillPathwayEnrollmentDataContext } from 'bundles/skills-common/shared/verified-skills/context/skill-pathway/SkillPathwayEnrollmentDataContext';
import useGetBadgeTemplates from 'bundles/skills-common/shared/verified-skills/data/pathway-badge/useGetBadgeTemplates';

type Props = {
  children: React.ReactNode;
};

const VerifiedSkillsBadgeDataProvider = ({ children }: Props) => {
  const { enrolledBadgeCollection, loading: loadingBadgeCollection } = useSkillPathwayEnrollmentDataContext();

  const badgeId = enrolledBadgeCollection?.badgeTemplateId || '';
  const isBadgeIssued = enrolledBadgeCollection?.userState === EnterpriseBadgeUserState.Issued;

  const { badgeTemplates, loading: loadingBadgeTemplates } = useGetBadgeTemplates(isBadgeIssued);

  const issuedBadgeTemplateForProgram = isBadgeIssued
    ? badgeTemplates?.badges?.find((template) => template?.badgeTemplate?.badgeTemplateId === badgeId)
    : undefined;

  const contextValue = {
    badge: issuedBadgeTemplateForProgram,
    loading: Boolean(loadingBadgeCollection || loadingBadgeTemplates),
  };

  return (
    <VerifiedSkillsBadgeDataContext.Provider value={contextValue}>{children}</VerifiedSkillsBadgeDataContext.Provider>
  );
};

export default VerifiedSkillsBadgeDataProvider;
